import { TGetExamDetailDto } from "@/api/services/main/learning-progress/dtos/exam/get-exam-detail-by-industry.dto";
import { state } from "@/theme/colors";
import { OpenInNew } from "@mui/icons-material";
import { Stack, styled, Typography } from "@mui/material";
import { FC } from "react";

export const ExamOverviewTab: FC<{ exam: TGetExamDetailDto | null }> = ({ exam }) => {
  return (
    <Stack gap={1.5}>
      {exam?.examOverview ? (
        <Typography variant="body14" whiteSpace="pre-line">
          {exam.examOverview}
        </Typography>
      ) : (
        <Typography variant="body14">
          試験情報は提供準備中です。
          <br />
          最新情報は試験実施元をご確認ください。
        </Typography>
      )}
      {exam?.examInfoSource && (
        <Stack flexDirection="row">
          <StyledExternalLink href={exam.examInfoSource} target="_blank" rel="noopener noreferrer">
            <Stack direction="row" alignItems="center" gap={0.5}>
              <Typography variant="body14" color={state.link_1}>
                {exam.examInfoSource}
              </Typography>
              <OpenInNew sx={{ fontSize: 16, color: state.link_1 }} />
            </Stack>
          </StyledExternalLink>
        </Stack>
      )}
    </Stack>
  );
};

const StyledExternalLink = styled("a")({
  textDecoration: "none",
});
